import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useFileSourceTemplatesStore } from "@/stores/fileSourceTemplatesStore";
import TemplateSummaryPopover from "./TemplateSummaryPopover.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TemplateSummarySpan',
    props: {
        templateId: null,
        templateVersion: null
    },
    setup(__props) {
        const props = __props;
        const fileSourceTemplatesStore = useFileSourceTemplatesStore();
        const template = computed(() => fileSourceTemplatesStore.getTemplate(props.templateId, props.templateVersion));
        const target = `template-summary-span-${crypto.randomUUID()}`;
        fileSourceTemplatesStore.ensureTemplates();
        return { __sfc: true, fileSourceTemplatesStore, props, template, target, TemplateSummaryPopover };
    }
});
